export default __webpack_public_path__ + "static/media/discover-colored.ca58f6a3.svg";